import { configureStore } from '@reduxjs/toolkit';
import partsReducer from './slices/partsSlice';
import equipmentReducer from './slices/equipmentSlice';
import ordersReducer from './slices/ordersSlice';
import stockReducer from './slices/stockSlice';
import equipmentTemplatesReducer from './slices/equipmentTemplatesSlice';
import repairsReducer from './slices/repairsSlice';
import customersReducer from './slices/customersSlice';
import dealersReducer from './slices/dealersSlice';
import devicesReducer from './slices/devicesSlice';
import usersReducer from './slices/usersSlice';

export const store = configureStore({
  reducer: {
    parts: partsReducer,
    equipment: equipmentReducer,
    orders: ordersReducer,
    stock: stockReducer,
    equipmentTemplates: equipmentTemplatesReducer,
    repairs: repairsReducer,
    customers: customersReducer,
    dealers: dealersReducer,
    devices: devicesReducer,
    users: usersReducer,
  },
});
